import { useLocation, useParams } from 'react-router';
import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import defaultImage from "../../assets/svg/defultImage.svg";
import noteIcon from "../../assets/svg/note-1-svgrepo-com 1.svg";
import Checkbox from "@mui/material/Checkbox";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from 'react-router';
import { Modal } from 'react-bootstrap';
import { DriveFolderUpload } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { newHost } from '../../pages/Categories/CategoryProfile';
import { newImageUrl } from '../../pages/Manufacturers/ManufactureProfile';
const CheckOrderItems = () => {


const { id: orderId } = useParams()
const location = useLocation()
// const order = location.state?.order
     const token = sessionStorage.getItem("token");
        const [order, setOrder] = useState(null);
        const [itemStatus, setItemStatus] = useState({}) 
        const [loading, setLoading] = useState(true)
        const [isChecked, setIsChecked] = useState({})
        const [isInspectionSaved, setIsInspectionSaved] = useState(false);
        const [isAfterImagesUploaded, setIsAfterImagesUploaded] = useState(false);
        const [inspectionStatus, setInspectionStatus] = useState({});
        const [otherItems, setOtherItems] = useState([]);
        const [otherItemStatus, setOtherItemStatus] = useState([]);
       

const getOrders = async () => {
  try {
    const response = await axios.get(
      `${newHost}stuff/get-order-products/${orderId}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    const order = response.data.data?.data;

    const statuses = {};
    order?.categories?.forEach(category =>
      category.subcategories?.forEach(sub =>
        sub.items?.forEach(item => {
          if (item.item_type === "other_request_service") return;

          const status = item.status || "pending";

          statuses[item.id] = {
            id: item.id,
            orderId: order.id,
            type: "normal",
            slug: category.slug,
            status,
            notes: item.rejection_reason || "",
            file: null,
            image_path: item.image_url || null,
            synced: status === "executed" || status === "rejected",
          };
        })
      )
    );
    order?.other_requests?.forEach(request =>
      request.services?.forEach(item => {
        const status = item.engineer_status || "pending";

        statuses[item.id] = {
          id: item.id,
          orderId: order.id,
          requestId: request.id,
          type: "other",
          isAccepted: item.status === "accepted_by_user",
          status,
          notes: item.engineer_rejection_reason || "",
          file: null,
          image_path: item.engineer_image_url || null,
          synced: status === "executed" || status === "rejected",
        };
      })
    );

    setInspectionStatus(statuses);
    setOrder(order);
    setOtherItems(order.other_requests || []);

    const hasSavedChecks = Object.values(statuses).some(
      item =>
        item.status === "executed" ||
        item.status === "rejected"
    );

    setIsInspectionSaved(hasSavedChecks);

  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};


const validInspectionItems = Object.values(inspectionStatus).filter(
  item =>
    item.type === "normal" && item.slug !== "cover" ||
    (item.type === "other" && item.isAccepted)
);

const isAllItemsChecked =
  validInspectionItems.length > 0 &&
  validInspectionItems.every(
    item =>
      item.status === "executed" ||
      item.status === "rejected"
  );


const getImagesAfter = async () => {
  try {
    const response = await axios.get(
      `${newHost}stuff/get-after-images/${orderId}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    const images = response.data.data?.images_after || [];
    setIsAfterImagesUploaded(images.length > 0);

  } catch (error) {
    console.log(error.response);
  }
};     
   useEffect(() => {
     getOrders()
      getImagesAfter()
      }, [])
     

     const boxStyle = {
              width: 25,
              height: 25,
              border: "2px solid #D1D5DB",
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            };


const handleStatusChange = (id, status, orderId) => {
  setInspectionStatus(prev => ({
    ...prev,
    [id]: {
      ...prev[id],
      status,
      orderId,
      synced: false,
    }
  }));
};
const submitItemsStatus = async (orderId) => {
  const formData = new FormData();

  const checkedItems = Object.values(inspectionStatus).filter(
    item =>
      item.orderId == orderId &&
      (item.status === "executed" ||
        item.status === "rejected")
  );

  const normalItems = checkedItems.filter(
    item => item.type === "normal"
  );

  const otherItems = checkedItems.filter(
    item => item.type === "other"
  );

  // =========================
  // NORMAL ITEMS
  // =========================
  normalItems.forEach((item, index) => {
    formData.append(`items[${index}][id]`, item.id);
    formData.append(
      `items[${index}][status]`,
      item.status
    );

    if (item.status === "rejected") {
      formData.append(
        `items[${index}][rejection_reason]`,
        item.notes || ""
      );

      if (item.file instanceof File) {
        formData.append(
          `items[${index}][image]`,
          item.file
        );
      } else if (item.image_path) {
        formData.append(
          `items[${index}][image_path]`,
          item.image_path
        );
      }
    }
  });

  // =========================
  // OTHER REQUEST ITEMS
  // =========================
  otherItems.forEach((item, index) => {
    formData.append(
      `other_requests[${index}][id]`,
      item.id
    );

    formData.append(
      `other_requests[${index}][status]`,
      item.status
    );

    if (item.status === "rejected") {
      formData.append(
        `other_requests[${index}][rejection_reason]`,
        item.notes || ""
      );

      if (item.file instanceof File) {
        formData.append(
          `other_requests[${index}][image]`,
          item.file
        );
      } else if (item.image_path) {
        formData.append(
          `other_requests[${index}][image_path]`,
          item.image_path
        );
      }
    }
  });

  try {
    const response = await axios.post(
      `${newHost}stuff/store-order-check/${orderId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    toast.success(response.data.message);

    setInspectionStatus(prev => {
      const updated = { ...prev };
      checkedItems.forEach(item => {
        updated[item.id] = { ...updated[item.id], synced: true };
      });
      return updated;
    });

    setIsInspectionSaved(true);

    navigate(
      `/ordersExecution/checkItems/${orderId}/imageAfter`
    );

  } catch (error) {
    console.log(error);
    toast.error(error.response?.data?.errors?.message);
  }
};


           const [showModal, setShowModal] = useState(false);
           const [currentItem, setCurrentItem] = useState(null);
           const [noteValue, setNoteValue] = useState("");
           const [imagePreview, setImagePreview] = useState(null)
           const [selectedFile, setSelectedFile] = useState(null);
           const [removeExistingImage, setRemoveExistingImage] = useState(false);
           const [isViewOnly, setIsViewOnly] = useState(false);
           const fileInputRef = useRef(null);



     const openModal = (service) => {
 const item = inspectionStatus[service.id];

if (item?.status !== "rejected") return;

setCurrentItem(service);
setIsViewOnly(Boolean(item.synced));
setNoteValue(item.notes || "");
setSelectedFile(item.file || null);
setRemoveExistingImage(false);

if (item.file) {
  setImagePreview(URL.createObjectURL(item.file));
} else if (item.image_path) {
  setImagePreview(`${newImageUrl}${item.image_path}`);
} else {
  setImagePreview(null);
}

setShowModal(true);

  }
 const saveNote = (note) => {
  if (!currentItem) return;

  setInspectionStatus(prev => ({
    ...prev,
    [currentItem.id]: {
      ...prev[currentItem.id],
      notes: note,
      file: selectedFile,
      image_path: selectedFile
        ? null
        : removeExistingImage
          ? null
          : prev[currentItem.id]?.image_path || null,
    }
  }));

  setShowModal(false);
};

    const FileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);
    setRemoveExistingImage(false);

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveImage = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setSelectedFile(null);
    setImagePreview(null);
    setRemoveExistingImage(true);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

   const [showExecuteModal, setShowExecuteModal] = useState(false)
  
    const handleCloseModal = () => {
      setShowExecuteModal(false)
    }

  const endOrderExecution = async () => {
  
    try {
      const response = await axios.get(`${newHost}stuff/end-execution/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      toast.success(response.data.message)
      handleCloseModal()
      getOrders()

    } catch (error) {
      console.log(error.response);
      toast.error(error.response?.data?.errors?.message)
    }
  }
const navigate = useNavigate()


  const handleAction = () => {
  if (order.status === "arrived_at_location") {
    navigate(`/ordersExecution/checkItems/${orderId}/imageBefore`, { state: { order } })
  }

else if (order.status === "in_progress") {
  if (!isInspectionSaved) {
    submitItemsStatus(orderId);
    
  } 
  else if (!isAfterImagesUploaded) {
    navigate(`/ordersExecution/checkItems/${orderId}/imageAfter`);
  } 
  else {
    setShowExecuteModal(true);
  }
}

  else if (order.status === "awaiting_payment") {
    navigate(`/ordersExecution/checkItems/${orderId}/confirmPayment`);
  }
};

const isDisabled = order?.status !== "in_progress";
  const renderServiceRow = (service) => {
  const itemData = inspectionStatus[service.id];
  const hasAttachment =
    itemData?.notes || itemData?.file || itemData?.image_path;

  return (
    <div
      key={service.id}
      className="row align-items-center border-bottom py-3"
    >
      {/* STATUS */}
      <div className="col-md-4 d-flex align-items-center gap-2">
        <Checkbox
          disabled={isDisabled}
          checked={
            inspectionStatus[service.id]?.status ===
            "executed"
          }
          onChange={() =>
      handleStatusChange(
        service.id,
        "executed",
        order?.id
      )
}
          icon={<div style={boxStyle} />}
          checkedIcon={
            <div
              style={{
                ...boxStyle,
                backgroundColor: "#3FBEAC"
              }}
            >
              <CheckIcon
                style={{ color: "#fff", fontSize: 18 }}
              />
            </div>
          }
        />

        <Checkbox
          disabled={isDisabled}
          checked={
            inspectionStatus[service.id]?.status ===
            "rejected"
          }
          onChange={() =>
            handleStatusChange(
              service.id,
              "rejected",
              order?.id
            )
          }
          icon={<div style={boxStyle} />}
          checkedIcon={
            <div
              style={{
                ...boxStyle,
                backgroundColor: "#A80101"
              }}
            >
              <CloseIcon
                style={{ color: "#fff", fontSize: 18 }}
              />
            </div>
          }
         
        />

        <p className="m-0">
          {service.service_name || service.title}
        </p>
      </div>

      {/* PRICE */}
      <div className="col-md-4">
        {Number(service.final_price).toLocaleString(
          "en-US"
        )}{" "}
        ج.م
      </div>

      {/* NOTES */}
      <div className="col-md-4 d-flex justify-content-end">
        <Badge
          color="error"
          variant="dot"
          overlap="circular"
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          invisible={!hasAttachment}
        >
          <img
            src={noteIcon}
            alt="note"
            onClick={() => openModal(service)}
            style={{
              width: 24,
              cursor: "pointer"
            }}
          />
        </Badge>
      </div>
    </div>
  );
};
const allowedStatuses = [
  "arrived_at_location",
  "in_progress",
  "awaiting_payment"
];

  return ( 
    <>
      <Modal show={showExecuteModal} onHide={handleCloseModal} dialogClassName='custom-modal-campaigns-width'>
            <Modal.Header className='d-flex align-items-center' >
              <Modal.Title className='fw-bold fs-5 text-center m-0'>
                تأكيد إنهاء الطلب
              </Modal.Title>
    
            </Modal.Header>
            <Modal.Body className='m-2' style={{ direction: "rtl" }}>
              <div className="text-center">
                <h5 className='main-modal-color'>هل أنت متأكد من إنهاء هذا الطلب؟ سيتم حفظ جميع البيانات وإغلاق الطلب بعد تأكيدك.</h5>
              </div>
              <div className='my-4'>
                <h6>
                  يرجى التأكد من الآتي قبل الإنهاء:
                </h6>
                <ul className='mx-4' style={{ listStyleType: "square", color: "#535353" }}>
                  <li className='my-2'>تم تنفيذ جميع الخدمات المطلوبة.</li>
                  <li className='my-2'>تم مراجعة التنفيذ بدقة.</li>
                  <li className='my-2'>لا توجد ملاحظات أو خدمات ناقصة.</li>
                </ul>
              </div>
            
              <div className="d-flex justify-content-center align-items-center  gap-4">
    
                <button onClick={endOrderExecution} className="btn btn-dark px-4">تأكيد وانهاء الطلب</button>
                <button onClick={handleCloseModal} className="btn btn-light px-5">الغاء</button>
    
              </div>
            </Modal.Body>
    
          </Modal>
     <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName='custom-modal-campaigns-width'>
        <Modal.Header className='d-flex align-items-center' >
          <Modal.Title style={{ direction: "rtl" }} className='fw-bold fs-5 text-center w-100 m-0'>
            {isViewOnly ? "تفاصيل الخدمه" : "إضافة تفاصيل للخدمه"}
          </Modal.Title>

        </Modal.Header>
        <Modal.Body className='m-2' style={{ direction: "rtl" }}>

          <div className="">
            <h6>
              {isViewOnly
                ? "الملاحظات المسجلة"
                : "اكتب ملاحظة أو ارفع صورة للجزء في حالة وجود مشكله"}
            </h6>
            {isViewOnly ? (
              <div
                style={{
                  padding: 20,
                  borderRadius: 10,
                  border: "solid 2px #D8D8D8",
                  backgroundColor: "#F8F8F8",
                  minHeight: 90,
                }}
                className="w-100"
              >
                {noteValue || (
                  <span className="text-muted">لا توجد ملاحظات</span>
                )}
              </div>
            ) : (
              <textarea value={noteValue} onChange={(e) => setNoteValue(e.target.value)} style={{ padding: 20, borderRadius: 10, border: "solid 2px #D8D8D8", }} rows={4} className='w-100' placeholder='اضف ملاحظاتك' id=""></textarea>
            )}

          </div>
          <div className='my-3'>
            <p>{isViewOnly ? "المرفقات" : "اضافة مرفقات"}</p>

            {imagePreview ? (
              isViewOnly ? (
                <img
                  src={imagePreview}
                  alt="preview"
                  style={{ width: "100%", height: 150, objectFit: "fill", borderRadius: 10 }}
                />
              ) : (
                <div
                  className="position-relative w-100"
                  style={{ border: "2px dashed #C6C6C6", borderRadius: 10 }}
                >
                  <Badge
                    overlap="rectangular"
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    sx={{ width: "100%", display: "block" }}
                    badgeContent={
                      <IconButton
                        size="small"
                        onClick={handleRemoveImage}
                        sx={{
                          backgroundColor: "#fff",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                          padding: "3px",
                          "&:hover": { backgroundColor: "#f2f2f2" },
                        }}
                      >
                        <CloseIcon sx={{ fontSize: 16, color: "#A80101" }} />
                      </IconButton>
                    }
                  >
                    <img
                      src={imagePreview}
                      alt="preview"
                      style={{
                        width: "100%",
                        height: 150,
                        objectFit: "fill",
                        borderRadius: 10,
                        display: "block",
                      }}
                    />
                  </Badge>
                </div>
              )
            ) : isViewOnly ? (
              <p className="text-muted mb-0">لا توجد صورة مرفقة</p>
            ) : (
              <label className="cursor w-100" htmlFor="upload-file">
                <div style={{ border: "2px dashed #C6C6C6" }} className="p-4 w-100 rounded-3 d-flex justify-content-center align-items-center">
                  <div className='text-center'>
                    <DriveFolderUpload sx={{ fontSize: "50px", color: "#535353" }} />
                    <p style={{ color: "#535353", margin: 0 }}>اضف ملف </p>
                  </div>
                </div>
              </label>
            )}

            {!isViewOnly && (
              <input
                type="file"
                accept="image/*"
                onChange={FileChange}
                ref={fileInputRef}
                className="d-none"
                id="upload-file"
              />
            )}
          </div>

          {!isViewOnly && (
            <div className="d-flex justify-content-center align-items-center my-5 gap-4">
              <button onClick={() => saveNote(noteValue)} className="btn btn-dark px-4">حفظ الفحص</button>
            </div>
          )}
        </Modal.Body>

      </Modal>
    <div className="m-4" dir="rtl">
      {loading || !order &&
   <div className="text-center my-5">Loading...</div>
}
       <div className="border rounded-4 min-vh-100">
         <div className="border rounded-4 p-4">
            <p className="m-0 fw-semibold">{`خدمات الطلب  # Order-${order?.id}`}</p>
        </div>
          <div className="p-4">
                      <div className="d-flex gap-3  m-3">
                        <span className="small fw-bold text-muted">تم</span>
                        <span className="small fw-bold text-muted">لم يتم</span>
                      </div>
                      
{order?.categories?.map(category => {
  const isOtherCategory = category.slug === "cover";

  return category.subcategories?.map(sub => {
   
    const acceptedOtherServices = isOtherCategory
      ? otherItems.flatMap(request =>
          request.services.filter(
            service => service.status === "accepted_by_user"
          )
        )
      : [];

    if (
      isOtherCategory &&
      acceptedOtherServices.length === 0
    ) {
      return null;
    }

    return (
      <div key={sub.id}>
        {/* Header */}
        <div className="d-flex gap-2 align-items-center pt-3">
          <img
            className="services-images-url"
            src={
              category.icon_url
                ? isOtherCategory
                  ? category.icon_url
                  : `${newImageUrl}${category.icon_url}`
                : defaultImage
            }
            alt=""
          />

          <h6 className="m-0 main-text-color">
            {sub.name}
          </h6>
        </div>

      

        {!isOtherCategory &&
          sub.items
            ?.filter(item => item.item_type !== "other_request_service")
            .map(service => renderServiceRow(service))}

        

        {isOtherCategory &&
          acceptedOtherServices.map(service =>
            renderServiceRow(service)
          )}
      </div>
    );
  });
})}
            </div>
        
       </div>
           <div className="d-flex justify-content-center mt-3 fixed-footer w-100">
{allowedStatuses.includes(order?.status) && (
  <button
  className='btn btn-dark px-5 w-75'
  disabled={order.status === "in_progress" && !isAllItemsChecked}
  onClick={handleAction}
>
  {order.status === "arrived_at_location" && "صور قبل التنفيذ"}

{order.status === "in_progress" && !isInspectionSaved && "صور بعد التنفيذ"}

{order.status === "in_progress" && isInspectionSaved && !isAfterImagesUploaded && "صور بعد التنفيذ"}

{order.status === "in_progress" && isInspectionSaved && isAfterImagesUploaded && "انهاء تنفيذ الطلب"}

{order.status === "awaiting_payment" && "تأكيد تنفيذ الطلب"}
</button>

)}
 
        </div>
    </div>
    
    </>
  )
}

export default CheckOrderItems




      // <Accordion
      //               key={category.id}
      //               expanded={expandedOrder === category.id}
      //               onChange={() =>
      //                 setExpandedOrder(
      //                   expandedOrder === category.id ? null : category.id,
      //                 )
      //               }
      //               sx={{
      //                 backgroundColor: "#F9F9F9",
      //                 my: 2,
      //                 py: 1,
      //                 border: "none",
      //                 outline: "none",
      //                 "&:before": {
      //                   display: "none",
      //                 },
      //                 "&.Mui-expanded": {
      //                   boxShadow: "none",
      //                 },
      //               }}
      //               className="shadow-sm"
      //             >
      //               <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      //                 <div className="row w-100 align-items-center">
      //                   <div className="col-12 d-flex align-items-center justify-content-between">
      //                     <div className="d-flex align-items-center gap-1">
      //                       <div className="services-images-url">
      //                         <img
      //                           src={
      //                             isOtherItem
      //                               ? category?.icon_url
      //                               : category?.icon_url
      //                                 ? `${newImageUrl}${category.icon_url}`
      //                                 : defaultImage
      //                           }
      //                           alt=""
      //                         />
      //                       </div>
      //                       <span className="fw-bold mx-2">{sub.name}</span>
      //                     </div>
      //                     <div className="">
      //                       <span className="main-text-color label-size">
      //                         3 / 0 مكتملة
      //                       </span>
      //                     </div>
      //                   </div>
      //                 </div>
      //               </AccordionSummary>

      //               <AccordionDetails>
      //                 {sub.items.map((item) => (
      //                   <div className="border rounded-3 p-3 my-3">
      //                     <div className="d-flex align-items-center justify-content-between my-3">
      //                       <h6 className="">{item?.service_name}</h6>
      //                       <div className="d-flex align-items-start gap-2">
      //                         <h6 className="fw-bold">{`${Number(item?.final_price).toLocaleString("en-US")} ج.م`}</h6>
      //                         <div
      //                           className="position-relative"
      //                           onClick={() => openModal(item)}
      //                         >
      //                           <img
      //                             src={noteIcon}
      //                             alt="note"
      //                             style={{
      //                               width: 24,
      //                               cursor: "pointer",
      //                             }}
      //                           />
      //                           {/* 
      //     {hasAttachment && (
      //       <Circle
      //         sx={{
      //           fontSize: 8,
      //           color: "#FF0B0B",
      //           position: "absolute",
      //           top: 0,
      //           right: 0
      //         }}
      //       />
      //     )} */}
      //                         </div>
      //                       </div>
      //                     </div>

      //                     <div className="d-flex align-items-center justify-content-between my-3">
      //                       <div className="d-flex gap-2">
      //                         <Chip
      //                           label={
      //                             <Box
      //                               display="flex"
      //                               alignItems="center"
      //                               gap={1}
      //                             >
      //                               <CircleIcon
      //                                 sx={{
      //                                   fontSize: 10,
      //                                   color: "#696969",
      //                                 }}
      //                               />
      //                               <span>لم تبدأ</span>
      //                             </Box>
      //                           }
      //                         />
      //                         <Chip
      //                           sx={{ bgcolor: "#FFFAEA" }}
      //                           label={
      //                             <Box
      //                               color={"#E29E04"}
      //                               display="flex"
      //                               alignItems="center"
      //                               gap={1}
      //                             >
      //                               <CircleIcon
      //                                 sx={{
      //                                   fontSize: 10,
      //                                 }}
      //                               />
      //                               <span>جاري التنفيذ</span>
      //                             </Box>
      //                           }
      //                         />
      //                         <Chip
      //                           sx={{ bgcolor: "#D8F3EF" }}
      //                           label={
      //                             <Box
      //                               color={"#159D89"}
      //                               display="flex"
      //                               alignItems="center"
      //                               gap={1}
      //                             >
      //                               <CircleIcon
      //                                 sx={{
      //                                   fontSize: 10,
      //                                 }}
      //                               />
      //                               <span>مكتملة</span>
      //                             </Box>
      //                           }
      //                         />
      //                       </div>
      //                       <div className="">
      //                         <span className="main-text-color label-size">
      //                           تم البدء 10:30 ص
      //                         </span>
      //                       </div>
      //                     </div>
      //                     <div className="d-flex align-items-center gap-3 my-3">
      //                       <button className="px-3 rounded-2 btn btn-dark d-flex gap-1 align-items-center">
      //                         <PlayCircleOutline fontSize="small" />
      //                         بدء تنفيذ الخدمة
      //                       </button>
      //                       <button className="px-3 rounded-2 btn btn-dark d-flex gap-1 align-items-center">
      //                         <CheckCircleOutlineOutlined fontSize="small" />
      //                         انهاء الخدمة
      //                       </button>
      //                       <button
      //                         onClick={handlePauseReasonShow}
      //                         style={{
      //                           border: "1px solid #696969",
      //                           color: "#696969",
      //                         }}
      //                         className="px-3 rounded-2 btn d-flex gap-1 align-items-center"
      //                       >
      //                         <PauseCircleOutlineOutlined fontSize="small" />
      //                         ايقاف مؤقت
      //                       </button>
      //                       <button
      //                         style={{
      //                           border: "1px solid #A80101",
      //                           color: "#A80101",
      //                         }}
      //                         className="px-3 rounded-2 btn d-flex gap-1 align-items-center"
      //                       >
      //                         <CancelOutlined fontSize="small" />
      //                         رفض الخدمة
      //                       </button>
      //                     </div>
      //                     <div className="d-flex align-items-center justify-content-between my-3">
      //                       <div className="d-flex align-items-center gap-2">
      //                         <CheckIcon />
      //                         <span>تم اكمال الخدمة بنجاح</span>
      //                       </div>
      //                       <div className="">
      //                         <IconButton
      //                           onClick={handleServicesDetailsShow}
      //                           sx={{ fontSize: "14px", color: "#000" }}
      //                           disableRipple
      //                           size="small"
      //                         >
      //                           عرض التفاصيل
      //                           <ChevronLeft size={14} />
      //                         </IconButton>
      //                       </div>
      //                     </div>
      //                   </div>
      //                 ))}
      //                 {/* <div className="border rounded-4 p-4">
      //               <ul style={{ listStyle: "square inside" }}>
      //                   <li>
      //                   {`اسم العميل: ${
      //                     order.user?.name
      //                       ? order?.user?.name
      //                       : "....."
      //                   }`}
      //                 </li>
      //                 <li className="my-1">
      //                   الخدمات المطلوبة:
      //                   {order.categories?.map((item) =>
      //                     item?.subcategories?.map((sub) => (
      //                       <div
      //                         key={sub.id}
      //                         className="d-flex align-items-center gap-2 m-0"
      //                       >
      //                         <div className="services-images-url">
      //                           <img
      //                             src={
      //                               item.icon_url
      //                                 ? item.slug === "cover"
      //                                   ? item.icon_url
      //                                   : `${newImageUrl}${item.icon_url}`
      //                                 : defaultImage
      //                             }
      //                             alt=""
      //                           />
      //                         </div>

      //                         <p className="m-0">{sub.name}</p>
      //                       </div>
      //                     )),
      //                   )}
      //                 </li>

      //                 <li className="my-1">{`العنوان: ${order?.address?.area}`}</li>

      //                 <li className="my-1">{`الوقت المتوقع: ${order?.scheduled_from} - ${order?.scheduled_to}`}</li>
      //                 {order.discount_total > 0 ? (
      //                   <>
      //                     <li>
      //                       اجمالي قبل الخصم:
      //                       <span className="fw-bold mx-2">
      //                         {Number(order?.subtotal).toLocaleString("en-US")}{" "}
      //                         ج.م
      //                       </span>
      //                     </li>
      //                     <li>
      //                       خصم:
      //                       <span className="fw-bold text-danger ms-2">
      //                         {Number(order.discount_total).toLocaleString(
      //                           "en-US",
      //                         )}{" "}
      //                         ج.م
      //                       </span>
      //                     </li>
      //                     <li>
      //                       الاجمالي:
      //                       <span className="fw-bold mx-2">
      //                         {Number(order?.total).toLocaleString("en-US")} ج.م
      //                       </span>
      //                     </li>
      //                   </>
      //                 ) : (
      //                   <li>
      //                     الاجمالي:
      //                     <span className="fw-bold mx-2">
      //                       {Number(order?.total).toLocaleString("en-US")} ج.م
      //                     </span>
      //                   </li>
      //                 )}
      //                 <li className="my-1 d-flex align-items-center">
      //                   حالة الطلب : {order?.order_status?.label_ar}
      //                   <div className="services-images-url mx-2" >
      //                     <img

      //                       src={order?.order_status?.image_url || defaultImage}
      //                       alt=""
      //                     />
      //                   </div>

      //                 </li>
      //               </ul>

      //               <div
      //                 className={`d-flex justify-content-center mt-3 ${order?.status == "completed" && "d-none"}`}
      //               >
      //                 <button
      //                   // onClick={() => navigateToCheckItems(order)}
      //                   className={`btn btn-dark px-5 w-50`}
      //                   disabled={
      //                     order.status !== "arrived_at_location" &&
      //                     order.status !== "in_progress" &&
      //                     order.status !== "awaiting_payment"
      //                   }
      //                 >
      //                   عرض الخدمات
      //                 </button>
      //               </div>
      //             </div> */}
      //               </AccordionDetails>
      //             </Accordion>